export default __webpack_public_path__ + "static/media/coding.eda75307.gif";